
import { BlogPost } from "@/types/blog";
import { content } from "./content";

export const CoachingAlsLebensphilosophie: BlogPost = {
  title: "Coaching als Lebensphilosophie: Haltung und Denkweise für persönliche Entwicklung",
  metaTitle: "Coaching als Lebensphilosophie: Haltung & Praxis",
  excerpt: "Entdecken Sie, wie Coaching als Haltung und Denkweise Ihre persönliche und berufliche Entwicklung fördern kann.",
  date: "14.02.2025",
  slug: "coaching-als-lebensphilosophie",
  imageUrl: "/images/blog/coaching-lebensphilosophie.jpg",
  category: "Coaching-Philosophie",
  tags: ["Coaching", "Lebensphilosophie", "Persönlichkeitsentwicklung", "Haltung", "Selbstreflexion"],
  author: "Jörg Hörmann",
  authorTitle: "Finanz- & Executive Coach",
  content
};
